export default __webpack_public_path__ + "static/media/shopping-cart.84c2ac19.svg";